import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'

import { Debounce, Bind } from 'lodash-decorators'

import Avatar from '@/components/Avatar/User/Avatar.vue'

@Component({
    mixins: [UserMixin],
    components: { Avatar },
})
export default class AutocompleteUser extends Mixins<MixinInterface>(UserMixin) {
    @Prop({ default: 'user' }) elementId!: any
    @Prop() value!: any
    @Prop({ default: () => [] }) initItems!: Array<any>
    @Prop({ default: 'user.label_user' }) label!: string
    @Prop() outlined!: boolean
    @Prop() dense!: boolean
    @Prop() disabled!: boolean
    @Prop() multiple!: boolean
    @Prop() required!: boolean
    @Prop({ default: true }) hideDetails!: boolean

    search = ''
    users: Array<any> = this.initItems
    loading = false

    fullName(person) {
        return person.attributes ? person.attributes.name : ''
    }

    @Watch('search')
    async searchUsers() {
        this.loading = true

        if (this.search?.trim().length > 1) {
            let params = { 'filter[kind]': 'normal', 'filter[searchTerm]': this.search }
            this.users = await this.getUsers(params).catch(() => {
                this.loading = false
            })
        } else {
            this.users = this.initItems
        }

        this.loading = false
    }

    passValue(data: any) {
        this.$emit('passValue', data)
    }
}
